import { render, staticRenderFns } from "./AuthorSmall.vue?vue&type=template&id=8f2eca54&scoped=true"
import script from "./AuthorSmall.vue?vue&type=script&lang=js"
export * from "./AuthorSmall.vue?vue&type=script&lang=js"
import style0 from "./AuthorSmall.vue?vue&type=style&index=0&id=8f2eca54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2eca54",
  null
  
)

export default component.exports